<template>
  <main>
    <HeroSection />
    <VideoSection />
    <StatsSection />

    <ToolSection @openBrief="$emit('openBrief', $event)" />
    <StorySection />
    <ExplainerSection />
    <BrievenSection @openTemplate="$emit('openTemplate', $event)" />

    <FaqSection />
  </main>
</template>

<script setup>
import HeroSection from '../components/HeroSection.vue'
import VideoSection from '../components/VideoSection.vue'
import StatsSection from '../components/StatsSection.vue'

import ToolSection from '../components/ToolSection.vue'
import StorySection from '../components/StorySection.vue'
import ExplainerSection from '../components/ExplainerSection.vue'
import BrievenSection from '../components/BrievenSection.vue'

import FaqSection from '../components/FaqSection.vue'

defineEmits(['openBrief', 'openTemplate'])
</script>
